import React from 'react';
import { Box, IconButton } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { useFormikContext } from 'formik';
import { Card, Typography } from '../../../ui-kit';
import { CreateSupplierForm } from '../../supplier';
import { CreateSupplierMutation } from '../../../generated/graphql';
import { SUPPLIER_ID_FIELD } from './DeliveryListForm/FormSteps/BasicInformation/constants';

interface DeliveryListCreateSupplierFormProps {
    onClose(): void;
    dialogName: string;
    setPassedSearchValue(value?: string): void;
}

const DeliveryListCreateSupplierForm = ({ onClose, dialogName, setPassedSearchValue }: DeliveryListCreateSupplierFormProps) => {
    const { setFieldValue } = useFormikContext();
    const onSubmitCallback = ({ createSupplier }: CreateSupplierMutation) => {
        setPassedSearchValue(createSupplier.legalName);
        setFieldValue(SUPPLIER_ID_FIELD, createSupplier.id);
        onClose();
    };

    return (
        <Card style={{ height: '100%', overflow: 'auto' }}>
            <Box px={3} py={2}>
                <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                    <ArrowBack />
                </IconButton>
                <Box mb={2} />
                <Typography variant='h6' component='h1'>{dialogName}</Typography>
                <CreateSupplierForm onCompleted={onSubmitCallback} isDialogView />
            </Box>
        </Card>
    );
};

export default DeliveryListCreateSupplierForm;
